import { PATHS } from '@/constants/Paths';
import { useNavigate } from 'react-router';
import CheckDoneIcon from '@/assets/icons/check-done-01.svg?react';
import ConfirmationModal from '@/components/ui/ConfirmationModal';
import { useTranslation } from '@/i18n';

interface CircuitSharedConfirmationModalProps {
  closeModal: () => void;
}

const CircuitSharedConfirmationModal = ({
  closeModal,
}: CircuitSharedConfirmationModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      closeModal={closeModal}
      title={t('distributors.modals.circuitSharedConfirmation.title')}
      message={t('distributors.modals.circuitSharedConfirmation.message')}
      icon={<CheckDoneIcon className="size-5" />}
      goBackTitle={t(
        'distributors.modals.circuitSharedConfirmation.viewMyDistributors',
      )}
      goBackAction={() => {
        navigate(PATHS.home.distributors.list);
      }}
      cancel={{
        title: t(
          'distributors.modals.circuitSharedConfirmation.continueAddingDistributors',
        ),
      }}
    />
  );
};

export default CircuitSharedConfirmationModal;
